/**
 * Fix accessibilità PDP:
 * - <th> vuoti / solo icona → span.sr-only
 * - <img> in <th> senza alt → alt descrittivo
 * - <ul>/<ol> con figli non-<li> → rimuove <br> o wrappa in <li>
 */
(function () {
  var ROOT_SELECTORS = ['.c-pdp', '.c-wide-accordions', '.js-pdp', 'article.c-pdp__outer'];

  function visibleText(el) {
    var clone = el.cloneNode(true);
    clone.querySelectorAll('.sr-only, .visually-hidden, [aria-hidden="true"]').forEach(function (n) {
      n.remove();
    });
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function ensureSrOnly(th, label) {
    if (th.querySelector('.sr-only, .visually-hidden')) return;
    var span = document.createElement('span');
    span.className = 'sr-only';
    span.textContent = label;
    th.insertBefore(span, th.firstChild);
  }

  function inferImgAlt(img) {
    var src = (img.getAttribute('src') || img.getAttribute('data-src') || '').toLowerCase();
    if (src.indexOf('temp') !== -1 || src.indexOf('degree') !== -1 || src.indexOf('boll') !== -1) {
      return 'Temperatura di infusione';
    }
    if (src.indexOf('time') !== -1 || src.indexOf('minut') !== -1 || src.indexOf('clock') !== -1) {
      return 'Tempo di infusione';
    }
    if (src.indexOf('quant') !== -1 || src.indexOf('spoon') !== -1 || src.indexOf('dose') !== -1) {
      return 'Quantità';
    }
    return 'Intestazione colonna';
  }

  function fixTableHeaders(root) {
    root.querySelectorAll('th').forEach(function (th) {
      var text = visibleText(th);
      var img = th.querySelector('img');
      var hasSvg = !!th.querySelector('svg');

      if (img) {
        var alt = img.getAttribute('alt');
        if (alt == null || !String(alt).trim()) {
          img.setAttribute('alt', inferImgAlt(img));
        }
      }

      if (!text) {
        if (img) return;
        if (hasSvg) {
          ensureSrOnly(th, 'Quantità');
          return;
        }
        ensureSrOnly(th, 'Valore');
      }
    });
  }

  function fixLists(root) {
    root.querySelectorAll('ul, ol').forEach(function (list) {
      [...list.children].forEach(function (child) {
        var tag = child.tagName.toLowerCase();
        if (tag === 'li') return;

        // <br> tra gli li: rimuovi
        if (tag === 'br') {
          child.remove();
          return;
        }

        // altri nodi (badge, widget, div): wrappa in <li>
        var li = document.createElement('li');
        list.insertBefore(li, child);
        li.appendChild(child);
      });
    });
  }

  function run() {
    var roots = [];
    ROOT_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        roots.push(el);
      });
    });
    if (!roots.length) roots = [document];
    roots.forEach(function (root) {
      fixTableHeaders(root);
      fixLists(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
